import { DateTime } from 'luxon'

type DayPoint = { date: string; count: number }

export const bucketByDay = <T>(items: T[], getDate: (i: T) => string) => {
  const map: Record<string, number> = {}
  for (const it of items) {
    const isoDay = new Date(getDate(it)).toISOString().slice(0, 10) // YYYY-MM-DD
    map[isoDay] = (map[isoDay] || 0) + 1
  }
  return Object.entries(map)
    .sort(([a], [b]) => (a < b ? -1 : 1))
    .map(([date, count]) => ({ date, count }))
}

// Running cumulative total plotted only on the days something actually
// happened. We deliberately do NOT emit a point for every calendar day in the
// range: on a time-scale x-axis the gaps are spanned by the line itself, and
// monotone-cubic interpolation (set on the dataset) turns the sparse points
// into a smooth, continuously-rising curve instead of a day-by-day staircase.
export const cumulativeSeries = (points: DayPoint[]): { x: number; y: number }[] => {
  let run = 0
  return points.map((p) => {
    run += p.count
    return { x: DateTime.fromISO(p.date).startOf('day').toMillis(), y: run }
  })
}
